import { CompositionsService } from '../../../services/CompositionsService';
import { Task, Tasks, tasks } from './-constants';

export async function getUserConversionState() {
  const canvases = await CompositionsService.getActiveCompositions();
  const hasCreatedSources = Object.values(canvases).some((canvas) => {
    return canvas.scenes.some((scene) => scene.sources.length > 0);
  });

  const hasCreatedCanvases = Object.values(canvases).length >= 2;
  const completedTasks: Record<Task, boolean> = {
    'new-setup': hasCreatedSources,
    'setup-multistreaming': hasCreatedCanvases,
  };

  const tasksToDo: Tasks = tasks.filter((task) => !completedTasks[task]);
  const tasksDone: Tasks = tasks.filter((task) => completedTasks[task]);

  console.log({
    hasCreatedSources,
    hasCreatedCanvases,
    tasksToDo,
    tasksDone,
    canvases,
  });

  return {
    hasCreatedSources,
    hasCreatedCanvases,
    tasksToDo,
    tasksDone,
  };
}
